// Who is signed in, for the pages that change with the role (« Mon compte »,
// « Ma productivité », the catalogue settings). The token's role claim is what
// the backend checks, so it wins; the stored userData (Login.js) is the
// fallback when the token cannot be read.
import jwtDecode from 'jwt-decode';

export const sessionRole = () => {
  try {
    const token = localStorage.getItem('access_token');
    const role = token ? jwtDecode(token)?.role : null;
    if (role) return role;
  } catch (error) {
    // Unreadable token: PrivateRoute sends the person to the login page.
  }
  try {
    return JSON.parse(localStorage.getItem('userData') || '{}').role || null;
  } catch (error) {
    return null;
  }
};

export const isEmployeeSession = () => sessionRole() === 'employee';
